import React, { useEffect, useState } from "react";
import { coulmnsType, DictionaryType, tableConfig } from "../../types";
import Table from "../custom/tableWrapper/Table";
import SkeletonTable from "../skeletons/SkeletonTable";
import deleteIcon from "../../assets/icons/deleteRed.svg";
import editIcon from "../../assets/icons/EDIT ICON.svg";
import {
  useGetAvailableCourtsForLeagueQuery,
  useGetAvailableCourtsForTournamentQuery,
} from "../../lib/redux/services/sections/Leagues-Tournaments";
import { UseFormSetValue, useWatch } from "react-hook-form";
import { checkSelectedCourts, cn } from "../../utils/utils";
import ModalButton from "../global/ModalButton";
import EditAvailableCourtsModel from "./EditAvailableCourtsModel";
import { FormType } from "./CreateForm";
import useMultiSelect from "../../hooks/useMultiSelect";
import { useParams } from "react-router-dom";
import { useGetDictionary } from "../../hooks/useGetDictionary";
import { Tooltip } from "react-tooltip";
import { Check, CircleHelp } from "lucide-react";
import ErrorSection from "../global/ErrorSection";
import { toast } from "react-toastify";

interface RequiredDays {
  total_required_days: number;
  group_days: number;
  matches_per_stage: {
    group_matches: number;
    quarter_final: number;
    semi_final: number;
    final: number;
  };
  quarter: number;
  semi_days: number;
  final_days: number;
  max_matches_per_day: number;
  max_per_one_time_slot: number;
}

type Props = {
  setAvailableCourtsLoading: any;
  availableCourtsLoading: boolean;
  availableCourtsParams: any;
  control: any;
  selectedCourts: any;
  isAllow: boolean;
  setValue: UseFormSetValue<FormType> | any;
  setSelectedCourtsLength: any;
  selectedCourtsLength: number;
  setAvailableCourtsParams: any;
  setSelectedCourts: any;
  getValue: any;
  setMatchCount: any;
  type: "leagues" | "tournaments";
  watch: any;
  stage?: "rounds" | "knockouts";
};

function AvailableCourtsTable({
  setAvailableCourtsLoading,
  availableCourtsLoading,
  availableCourtsParams,
  isAllow,
  control,
  setMatchCount,
  getValue,
  selectedCourts,
  setSelectedCourtsLength,
  selectedCourtsLength,
  watch,
  setSelectedCourts,
  setValue,
  setAvailableCourtsParams,
  type,
  stage
}: Props) {
  
  const { id } = useParams();
  const { leagues_tournaments }: DictionaryType = useGetDictionary();
  const [courts, setCourts] = useState([]);
  const [requiredDays, setRequiredDays] = useState<RequiredDays | null>(null);
  const test = useWatch({
    control,
    name: "available_courts",
  });
  const { searchForItem } = useMultiSelect();
  const [available_Courts, setAvailableCourts] = useState<any>([]);
  const [availableCourtsData, setAvailableCourtsData] = useState<any>([]);

  const getFunction =
    type === "leagues"
      ? useGetAvailableCourtsForLeagueQuery
      : useGetAvailableCourtsForTournamentQuery;
  const { data, isLoading, isError, isFetching, isSuccess, refetch,error } =
    getFunction({...availableCourtsParams,phase:stage === "rounds" ? "groups" : "knockouts"}, {
      skip: !availableCourtsLoading,
    });
  const handleDelete = (id: number) => {
    const newTest = getValue("available_courts_ids").filter(
      (item: number) => item !== id,
    );

    setValue(
      "available_courts_ids",
      getValue("available_courts_ids").filter((item: number) => item !== id),
    );
    setValue("unwanted_courts", [...getValue("unwanted_courts"), id]);
    setAvailableCourtsData((prev: any) =>
      prev.filter((item: any) => item.id !== id),
    );
    setSelectedCourts((prev: any) => {
      const newSelectedCourts = { ...prev };
      delete newSelectedCourts[id];
      setValue("available_courts", newSelectedCourts);
      return newSelectedCourts;
    });
  };
  const handleSelect = (rowId: number, item: any) => {
    if (selectedCourts[rowId]) {
      const isFound = searchForItem(item, selectedCourts[rowId]) >= 0;
      if (isFound) {
        if (selectedCourts[rowId].length === 1) {
          setSelectedCourts((prev: any) => {
            const newSelectedCourts = { ...prev };
            delete newSelectedCourts[rowId];
            setValue("available_courts", newSelectedCourts);
            return newSelectedCourts;
          });
          setSelectedCourtsLength(selectedCourtsLength - 1);
        } else {
          setSelectedCourtsLength(selectedCourtsLength - 1);
          setSelectedCourts((prev: any) => {
            setValue("available_courts", {
              ...test,
              [rowId]: selectedCourts[rowId].filter(
                (court: any) => court.id !== item.id,
              ),
            });
            return {
              ...prev,
              [rowId]: prev[rowId].filter((court: any) => court.id !== item.id),
            };
          });
        }
      } else {
        setSelectedCourtsLength(selectedCourtsLength + 1);
        setSelectedCourts((prev: any) => {
          setValue("available_courts", {
            ...test,
            [rowId]: [...test[rowId], item],
          });
          return {
            ...prev,
            [rowId]: [...prev[rowId], item],
          };
        });
      }
    } else {
      setSelectedCourtsLength(selectedCourtsLength + 1);
      setSelectedCourts((prev: any) => ({
        ...prev,
        [rowId]: [item],
      }));
      setValue("available_courts", {
        ...test,
        [rowId]: [item],
      });
    }
  };
  // const {data,isLoading,isError,isFetching,isSuccess} =useGetAvailableCourtsForTournamentQuery(availableCourtsParams,{
  //   skip:!availableCourtsLoading
  // })

  useEffect(() => {
    setCourts(watch("court_ids"));
    if (isSuccess) {
      // console.log(data?.required_days);
      setRequiredDays(data?.required_days);
      setValue(
        "available_courts_ids",
        data?.data?.map((item: any) => item.id),
      );

      setAvailableCourtsLoading(false);
    }
  }, [data, isSuccess]);
  useEffect(() => {
    if (data) {
      setMatchCount(data?.matches_count);
      if (getValue("state") === "Draft") {
        setValue("available_courts", []);
      }
      setAvailableCourtsData(data?.data);

      if (
        availableCourtsParams?.available_courts?.length === 0 ||
        !availableCourtsParams?.available_courts
      ) {
        setAvailableCourtsParams({
          ...availableCourtsParams,
          available_courts: data?.data?.map((item: any) => item.id),
        });
      }
      checkSelectedCourts(
        selectedCourts,
        data?.data,
        setSelectedCourts,
        setSelectedCourtsLength,
        setValue,
      );
    } else {
      if (getValue("state") === "Draft") {
        setAvailableCourtsData(getValue("available_courts"));
        setAvailableCourtsParams({
          ...availableCourtsParams,
          available_courts: getValue("available_courts").map(
            (item: any) => item.id,
          ),
        });
        setValue(
          "available_courts_ids",
          getValue("available_courts").map((item: any) => item.id),
        );
        setValue("available_courts", []);
      }
    }
  }, [data]);
  if (isLoading || isFetching) {
    return <SkeletonTable />;
  }
  if (isError) {
    //@ts-ignore
    toast.error(error?.message || error?.error?.message ||error?.error); 
    setAvailableCourtsLoading(false);
    return <ErrorSection />;
  }

  const columns: coulmnsType = [
    {
      title: leagues_tournaments.available_courts_table?.round_number,
      tag: "line_number",
    },
    {
      title: leagues_tournaments.available_courts_table?.day,
      tag: "day",
    },
    {
      title: leagues_tournaments.available_courts_table?.date,
      tag: "date",
    },
    {
      title: leagues_tournaments.available_courts_table?.time,
      tag: "time",
    },
    {
      title: "Slots",
      tag: "slots",
    },
    {
      title: "",
      tag: "available_Courts",
      //@ts-ignore
      htmlElement: () => {
        return (
          <div>
            <Tooltip
              id="my-tooltip"
              style={{
                backgroundColor: "#f3f3f3",
                color: "#1e1850",
                top: "0px",
                zIndex: 1000,
              }}
              place="top"
            >
              {requiredDays && (
                <p className="text-start">
                  {`You need at least ${requiredDays?.total_required_days} days.`}
                  <br />
                  {`Note that stages can not overlap!! Allocate court slots in the order shown below.`}
                  <br />
                  {`at least ${requiredDays?.group_days} days for ${requiredDays?.matches_per_stage?.group_matches} group matches`}
                  <br />
                  {`at least ${requiredDays?.quarter} days for `}
                  {`${requiredDays?.matches_per_stage?.quarter_final} quarter final matches (if player number more than 20 we have quarters)`}

                  <br />
                  {`at least ${requiredDays?.semi_days} days for ${requiredDays?.matches_per_stage?.semi_final} semi-final matches `}
                  <br />
                  {`at least ${requiredDays?.final_days} days for ${requiredDays?.matches_per_stage?.final} final matches `}
                  <br />
                  {`please set no more than ${requiredDays?.max_matches_per_day} matches per day no more than ${requiredDays?.max_per_one_time_slot} matches at one time slot`}
                </p>
              )}
            </Tooltip>
            <div className="flex flex-row justify-center items-center gap-2">
              <p>
                {leagues_tournaments.available_courts_table?.available_courts}
              </p>
              {requiredDays && (
                <span className="text-xs ">
                  <CircleHelp
                    color="#1E1850 "
                    size={15}
                    className="cursor-context-menu"
                    data-tooltip-id="my-tooltip"
                    // data-tooltip-html={}
                  />
                </span>
              )}
            </div>
          </div>
        );
      },
    },
   
  ];

  const config: tableConfig = {
    line_number: {
      columnCellClassName: " w-[150px] min-w-[150px] max-w-[150px]",
      tdClassName: "w-[150px] min-w-[150px] max-w-[150px]",
      customClassName: "w-[150px] min-w-[150px] max-w-[150px]",
    },
    day: {
      columnCellClassName: " w-[100px] min-w-[100px] max-w-[100px]",
      tdClassName: "w-[100px] min-w-[100px] max-w-[100px]",
      customClassName: "w-[100px] min-w-[100px] max-w-[100px]",
    },
    time: {
      columnCellClassName: " w-[220px] min-w-[220px] max-w-[220px]",
      isCustomViewChildren: true,
      customViewChildren: (rowData, tag) => {
        return (
          <td className=" p-4 flex-1  w-[220px] min-w-[220px] max-w-[220px]     relative cursor-pointer">
            <p className="text-primary dark:text-white  w-full">
              <strong className="pr-2">{rowData?.time}</strong>
            </p>
          </td>
        );
      },
    },
    available_Courts: {
      isCustomViewChildren: true,
      customViewChildren: (rowData, tag) => {
        const availableCourts = rowData?.court_ids.map(
          (court: any) => court.id,
        );
        if (tag === "available_Courts") {
          rowData?.court_ids.forEach((element: any) => {
            const isFound = searchForItem(element, availableCourts);
            if (isFound > -1) {
              setAvailableCourts((prev: any) => [...prev, element]);
            }
          });
        }
        const courtsList = watch("court_ids");
        return (
          <td className=" p-4 min-w-[240px] w-full flex-grow   relative cursor-pointer">
            <div className="w-full flex justify-between">
              <div className="text-primary dark:text-white  w-fit flex gap-2 items-center  overflow-x-auto customScroll cursor-default pb-2 mx-auto">
                {courtsList.map((court: any) => {
                  return (
                    
                    <p
                      key={court.id}
                      className={cn(
                        "p-2  ml-2 px-4   whitespace-nowrap cursor-pointer rounded-full",
                        availableCourts.includes(court.id)
                          ? availableCourtsData.length > 0
                            ? "bg-[#E2F0E9] text-primaryGreen border border-[#A3DEB9] dark:text-white"
                            : "bg-[#B3D0FF3B] text-primary border border-[#7096FF]"
                          : " text-primaryRed bg-[#EF462624] border border-[#FF8E78C9] line-through",
                        selectedCourts[rowData.id] &&
                          selectedCourts[rowData.id]
                            ?.map((court: any) => court.id)
                            .includes(court.id) &&
                          "bg-[#B3D0FF3B] text-primary border border-[#7096FF]",
                      )}
                      onClick={() => {
                        if (
                          availableCourts.includes(court.id) &&
                          availableCourtsData.length > 0
                        ) {
                          handleSelect(rowData.id, court);
                        }
                      }}
                    >
                      <span className={cn("w-3 h-3 rounded-full bg-primaryRed inline-block mr-2",
                        availableCourts.includes(court.id)
                          ? availableCourtsData.length > 0
                            ? "bg-primaryGreen "
                            : "hidden "
                          : " bg-primaryRed ",
                        selectedCourts[rowData.id] &&
                          selectedCourts[rowData.id]
                            ?.map((court: any) => court.id)
                            .includes(court.id) &&
                          "hidden ",
                      )}></span>
                      
                      {(selectedCourts[rowData.id] &&
                          selectedCourts[rowData.id]
                            ?.map((court: any) => court.id)
                            .includes(court.id) || (availableCourts.includes(court.id) && availableCourtsData.length === 0)) && <Check className="text-primary inline-block mr-2" size={18} />}
                      {court.name}
                    </p>
                  );
                })}
              </div>
            </div>
          </td>
        );
      },
    },
    slots: {
       columnCellClassName: " w-[80px] min-w-[80px] max-w-[80px]",
      isCustomViewChildren: true,
      customViewChildren: (rowData, tag) => {
        const courtsList = watch("court_ids");
        return (
          <td className=" p-4 flex-1  w-[80px] min-w-[80px] max-w-[80px]     relative cursor-pointer">
            <p className="text-primary dark:text-white  w-full">
              <span className="pr-2">{selectedCourts[rowData.id]?.length || 0}/{courtsList.length}</span>
            </p>
          </td>
        );
      },
    }
  };

  return (
    <div className="flex flex-col  w-full bg-white rounded-2xl p-4">
      <div className="flex gap-4 items-center w-full justify-between">
        {/* <div className="flex gap-4 items-center">
          <h3 className="font-bold text-lg text-primary dark:text-white pr-2 mobile:text-[12px] mobile:whitespace-nowrap">
            {leagues_tournaments.available_courts}
          </h3>
          <div className="flex gap-2 items-center">
            <span className="w-2 h-2 rounded-full bg-[#CCCCCC]"></span>{" "}
            {leagues_tournaments.available}
          </div>
          <div className="flex gap-2 items-center">
            {" "}
            <span className="w-2 h-2 rounded-full bg-[#EF4626]"></span>{" "}
            {leagues_tournaments.booked}
          </div>
          <div className="flex gap-2 items-center">
            {" "}
            <span className="w-2 h-2 rounded-full bg-primary"></span>{" "}
            {leagues_tournaments.selected}
          </div>
        </div> */}

        
      </div>
       <div className="w-full bg-[#F5F6F6] flex justify-between items-center pt-[18px] pb-[12px] px-6 rounded-t-2xl">
        <div className="flex gap-5 items-center">
          
          <div className="flex gap-2 items-center">
            <span className="w-3 h-3 rounded-full bg-primaryGreen"></span>{" "}
            {leagues_tournaments.available}
          </div>
         
          <div className="flex gap-2 items-center">
            {" "}
            <span className="w-3 h-3 rounded-full bg-primary"></span>{" "}
            {leagues_tournaments.selected}
          </div>
           <div className="flex gap-2 items-center">
            {" "}
            <span className="w-3 h-3 rounded-full bg-[#EF4626]"></span>{" "}
            {leagues_tournaments.booked}
          </div>
        </div>
        {data &&<div>
          <p className="text-primaryRed font-semibold">{selectedCourtsLength}/
            {data?.matches_count} Slots</p>
        </div>}
       </div>
      <div className=" customer-table">
        <Table
          columnsData={
            availableCourtsData.length > 0
              ? columns
              : columns.filter((item: any) => item.tag !== "btns")
          }
          rowData={
            availableCourtsData.length > 0
              ? availableCourtsData
              : Object.keys(watch("available_courts")).length
                ? watch("available_courts")
                : []
          }
          tableClassName="border border-[#E1E6ED] rounded-t-none"
          generalCellColumnClassName="w-[150px] min-w-[150px] max-w-[150px] [&:nth-child(6)]:w-full [&:nth-child(6)]:flex-grow [&:nth-child(6)]:max-w-none  "
          generalCellRowClassName="  min-w-[150px] w-[150px] w-full overflow-hidden text-left flex-1"
          generalRowClassName=" text-left flex  w-full"
          generalColumnsClassName=" bg-white text-primary dark:text-white  static text-center items-left border-b border-gray-200 dark:border-slate-700 "
          config={config}
        />
      </div>
    </div>
  );
}

export default AvailableCourtsTable;
